import { render, staticRenderFns } from "./BlogCardsCarousel.vue?vue&type=template&id=841cbe04&lang=pug"
import script from "./BlogCardsCarousel.vue?vue&type=script&lang=js"
export * from "./BlogCardsCarousel.vue?vue&type=script&lang=js"
import style0 from "./BlogCardsCarousel.vue?vue&type=style&index=0&id=841cbe04&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports